import { Helmet } from "components/Helmet";
import { useLayoutStore } from "layout/store";
import { useEffectOnce } from "std/hooks/useEffectOnce";

type HelmetWithBreadcrumbsProps = {
	title: string;
	breadcrumbs?: string[];
};

export const useSetBreadcrumbs = (breadcrumbs: string[] | undefined) => {
	const currentBreadcrumbs = useLayoutStore((s) => s.breadcrumbs);

	const setBreadCrumbs = () => {
		if (JSON.stringify(breadcrumbs) === JSON.stringify(currentBreadcrumbs)) {
			return;
		}

		useLayoutStore.setState({ breadcrumbs });
	};

	useEffectOnce(setBreadCrumbs);
};

export function HelmetWithBreadcrumbs(props: HelmetWithBreadcrumbsProps) {
	const { title, breadcrumbs } = props;
	useSetBreadcrumbs(breadcrumbs);
	return <Helmet title={title} />;
}
